{
  "theme": {
    "dark": "Dark Theme",
    "main": "Main Theme"
  },
  "projectCustomisation": {
    "projectDetails": "Project details",
    "editDetails": "Edit details",
    "projectName": "Project name",
    "projectNameHelperText": "Max 24 characters",
    "projectLogoTitle": "Project logo",
    "projectLogoHint": "This image will be shown in the top navigation bar and on the project login page",
    "projectLogoRemoveTitle": "Remove the logo image from this project",
    "projectLogoRemoveText": "This will remove the logo image file and everyone with access to the project will no longer see it. Are you sure you wish to continue?",
    "projectLogoRestrictionHint": "Max image size is 1920px (height) and 1080px (width)",
    "projectImageTitle": "Project image",
    "projectImageHint": "This image will be shown in the project card and dashboard",
    "projectImageRemoveTitle": "Remove the image from this project",
    "projectImageRemoveText": "This will remove the image file and everyone with access to the project will no longer see it. Are you sure you wish to continue?",
    "projectImageRestrictionHint": "Max image size is 1920px (height) and 1080px (width)"
  },
  "scheduleConfig": {
    "title": "Schedule Configuration",
    "description": "The schedule can be configured using the settings below. Only make changes here if you have a detailed understanding of how the schedule configuration works. If you are unsure, contact Iventis support:",
    "save": "Save schedule changes",
    "timesAndDates": "Times and Dates",
    "venueTypeHierarchy": "Venue Type Hierarchy",
    "scheduleVersionHierarchy": "Schedule Version Hierarchy",
    "eventBlockHierarchy": "Event Block Hierarchy",
    "venueRunSheets": "Venue Run Sheets (DCAS)",
    "timezone": "Timezone",
    "dayStartTime": "Start time for each day",
    "dayEndTime": "End time for each day",
    "projectStartDate": "Project start date",
    "projectEndDate": "Project end date",
    "projectZeroDate": "Project day 0",
    "eventBlockTitleTop": "Top Level Calendar Event Blocks",
    "eventBlockTitleSecond": "Second Level Calendar Event Blocks",
    "eventBlockTitleThird": "Third Level Calendar Event Block",
    "eventBlockTitleDefault": "Level Calendar Event Block",
    "eventBlockTypeName": "Event Block Type Name",
    "eventBlockApiSingle": "API Name Singular",
    "eventBlockApiPlural": "API Name Plural",
    "eventBlockAllowedVenueTypes": "Allowed Venue Types",
    "eventBlockRelativeTypes": "Can Be Relative To Types",
    "eventBlockSummaryText": "Attributes of Child Event Block to use in Summary",
    "eventBlockDCAS": "Can be created inside the DCAS",
    "eventBlockCustomerIdentifier": "Customer identifier",
    "clusterVenueLocationTemplateTitle": "Cluster venue location template",
    "mainVenueLocationTemplateTitle": "Main venue location template",
    "subVenueLocationTemplateTitle": "Sub venue location template",
    "enableClusters": "Enable clusters",
    "editVenues": "Edit venues",
    "venueLocations": "Venue Locations",
    "venueLocationTypeName": "Venue Location Type Name",
    "attributes": "Attributes",
    "scheduleVersionTopLevelTitle": "Top Level Schedule Version",
    "scheduleVersionSecondLevelTitle": "Second Level Schedule Version",
    "scheduleVersionLevelTitle": "Level Schedule Version",
    "scheduleVersionName": "Schedule Version Name",
    "problems": "There are {{ problemCount }} problems with the submitted schedule configuration",
    "dcasEventBlock": "Event Block for Run Sheet",
    "dcasEventBlockQuestion": "Enable run sheet only event block",
    "dcasEventBlockCalendar": "Event Blocks To Use",
    "dcasEventBlockAttributes": "Attributes for Run Sheet",
    "dcasEnableDone": "Mark activities with \"Done\"",
    "calendarLevel": {
      "0": "session",
      "1": "scheduled item",
      "activity": "activity"
    }
  }
}